import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FcOutlinedMultiSelectComponent } from './fc-outlined-multi-select.component';

@NgModule({
  declarations: [
    FcOutlinedMultiSelectComponent
  ],
  imports: [
    FormsModule,
    PipesModule,
    CommonModule,
    TranslateModule,
    FuseSharedModule,
    ReactiveFormsModule,

    MatIconModule,
    MatRippleModule,
    MatTooltipModule,
    MatCheckboxModule
  ],
  exports: [
    FcOutlinedMultiSelectComponent
  ]
})
export class FcOutlinedMultiSelectModule { }
